<div class="overlay-spinner" *ngIf="LoaderStatus">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-warning" style="width: 3rem; height: 3rem; " role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>

<div *ngIf="LoaderStatus && oauhtInd" class="container-fluid d-flex flex-column p-0 banner-bg vh-100" style="min-height: 100%">
  <app-oauth-callback></app-oauth-callback>
  <!-- <app-footer></app-footer> -->
</div>

<div *ngIf="LoaderStatus === false && !RegisterAgentOnly" class="container-fluid d-flex flex-column p-0 banner-bg vh-100" style="min-height: 100%">
  <app-header></app-header>
  <div class="flex-column vh-100" style="margin-top: 73px">
    <app-sidebar (RolesChanged)="ChangeFirm($event)"></app-sidebar>
    <div style="margin-left: 5rem;">
      <app-user-top [FirmID]="FirmIDChange"></app-user-top>
      <router-outlet></router-outlet>
    </div>
  </div>
  <!-- <app-footer></app-footer> -->
</div>


<div *ngIf="LoaderStatus === false && RegisterAgentOnly" class="container-fluid d-flex flex-column p-0 banner-bg vh-100" style="min-height: 100%">
  <app-user-top [FirmID]="FirmIDChange"></app-user-top>
  <app-butiran-daftar-kemaskini></app-butiran-daftar-kemaskini>
  <!-- <app-footer></app-footer> -->
</div>

